import * as React from 'react';
export const cadencebankSvg = React.forwardRef(function cadencebankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#004F5B',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.547 15.534c.743-.473.13-.09.898-.571.294-.18.49-.376.629-.531.147-.171.392-.098.424.114.261 1.519-.522 2.948-1.78 3.74l-1.6 1.012c-.147.09-.319.017-.36-.155-.391-1.567.458-2.768 1.789-3.617v.008Zm-1.797-3.65c-1.298.817-2.188 2.066-1.788 3.65.041.147.196.22.327.139l3.241-2.05c1.274-.808 2.066-2.261 1.764-3.804-.032-.188-.261-.237-.384-.09a2.55 2.55 0 0 1-.661.571c-.767.482-1.217.776-2.515 1.593l.016-.009ZM15.717 9.82c-1.34.849-2.197 2.065-1.78 3.65.04.146.196.22.327.138l5.43-3.437c1.281-.809 2.065-2.27 1.763-3.813-.033-.18-.261-.237-.384-.09a2.698 2.698 0 0 1-.661.571l-4.695 2.973v.008Zm-.555-4.279c-1.315.833-2.164 2.025-1.805 3.576a.266.266 0 0 0 .409.172l2.163-1.372c1.241-.784 2.017-2.18 1.788-3.674a.27.27 0 0 0-.473-.147 2.802 2.802 0 0 1-.596.49l-1.503.955h.017Z',
      fill: '#24A926',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.672 24.197c.743-.473.13-.09.898-.571.294-.18.49-.376.63-.53.146-.172.391-.099.424.113.261 1.52-.523 2.948-1.78 3.74l-1.6 1.012c-.148.09-.319.017-.36-.155-.392-1.567.457-2.768 1.788-3.617v.008Zm-1.796-3.65c-1.298.817-2.188 2.066-1.788 3.65.04.147.196.22.326.14l3.242-2.05c1.274-.809 2.066-2.262 1.764-3.805-.033-.188-.262-.237-.384-.09a2.551 2.551 0 0 1-.662.572c-.767.481-1.216.775-2.514 1.592l.016-.008Zm-4.034-2.065c-1.339.849-2.196 2.066-1.78 3.65.041.147.196.22.327.138l5.43-3.437c1.282-.808 2.066-2.27 1.763-3.813-.032-.18-.26-.237-.383-.09a2.697 2.697 0 0 1-.662.572l-4.695 2.972v.008Zm-.555-4.279c-1.314.833-2.164 2.025-1.804 3.577.04.187.245.277.408.171l2.164-1.372c1.24-.784 2.017-2.18 1.788-3.674a.27.27 0 0 0-.474-.147 2.803 2.803 0 0 1-.596.49l-1.502.955h.016Z',
      fill: '#fff',
    }),
  );
});
cadencebankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cadencebank = {
  category: 'brand',
  colorable: false,
  name: 'cadencebank',
  svg: cadencebankSvg,
};
